export default __webpack_public_path__ + "static/media/favicon.556925ae.ico";